import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Errors, FooterService, LocalService } from '../core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { DomSanitizer } from '@angular/platform-browser';
import { CheckDateValidityPipe } from 'src/app/shared/pipe/check-date-validity.pipe';
import { MatDialog } from '@angular/material';

import { ApproverService } from '../core/services/approver.service';
import { PopupMessageService } from '../shared/message/services/message.service';
import { ApproverconformationComponent } from '../approverconformation/approverconformation.component';
@Component({
  selector: 'app-approver',
  templateUrl: './approver.component.html',
  styleUrls: ['./approver.component.scss']
})
export class ApproverComponent implements OnInit {

  userProfile:any=null;
  sliderData: any = [];
  errors: Errors = { errors: {} };
  fired = 0;
  imageUrlArray: any;
  slideConfig1 = {"slidesToShow": 1, "slidesToScroll": 2, dots: true,arrows:false,speed: 300,infinite: true,autoplay:true,autoplaySpeed:5000};
  showChatScreen: boolean = false;
  activityList:any=[];
  activityName:any;
  approverList=null;
  page = 1;
  size = 4;
  selectedActivityId:any;
  approvedCount:any=0;
  rejectedCount:any=0;
  pendingApprovalCount:any=0;
  partnerName:any='';
  partnerUser:any='';
  category:any='';
  approverEmail:any='';
  approvalStatus:any='';
  searchDiv:boolean=false;
  searchCount=0;
  closeIconFlag:boolean=false;
  @ViewChild('slickModalBanner') slickModalBanner: SlickCarouselComponent;
 
  constructor(@Inject(DOCUMENT) private document: Document,
  private approverService:ApproverService,
  private sanitizer: DomSanitizer,
  private dialog: MatDialog,
  private popupMessageService: PopupMessageService,
  private footerService: FooterService) { }

  ngOnInit() {
    this.loadCiscoStyles('client-cisco.css');
    this.userProfile = LocalService.get('userProfile');
    let role=LocalService.get('approverRole')
    this.loadBannerImages();
    this.getscrollBanners();
    this.getActivityChgList();
   
  }
  loadCiscoStyles(styleName) {
    const head = this.document.getElementsByTagName('head')[0];
    const styleLink = this.document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.classList.add('cisco_styles')
    styleLink.href = styleName;
    head.appendChild(styleLink);
  };
  getscrollBanners() {
    this.getSliderImages();
  }
  getSliderImages() {
    var regNm;
    regNm = this.userProfile.company.region;

    const queryParams = {
      region: regNm,
      console: localStorage.getItem('selectedRole') == 'manager' ? 'LEADER' : 'SELLER'
      // roles:[],
      // beGeoIds:[]
    }
    //console.log('this.switchRole ',this.switchRole )
    this.footerService.getSliderImages(queryParams).subscribe((data) => {
      this.sliderData = [];
      this.sliderData.push(data[0]);
      // data.forEach(element => {
      //   if (element.startDate == null || element.endDate == null) {
      //     this.sliderData.push(element);
      //   }
      //   else {
      //     if (this.checkDateValidity(element)) this.sliderData.push(element);
      //   }
      // });
      // this.sliderData = data;      
      // if(this.bannerData.length >1) this.showDots = true;
      // this.slideConfig2 = {"slidesToShow": 1, "slidesToScroll": 1, dots: this.showDots,arrows:false,speed: 300,infinite: true,autoplay:true,autoplaySpeed:5000};
    }, err => {
      this.errors = err;
    });
  }
  sliderChange(event) {
    if (event.currentSlide >= 0) {
      this.fired += 1;
    }
    //console.log($event,this.imageUrlArray.length,this.fired)
    // this.currentIndex = event.currentSlide ;
    if (event.currentSlide == 0) {
      if (this.imageUrlArray.length == this.fired) {
        // this.autoplaySlider = false;
        this.slickModalBanner.slickPause();
        this.fired = 0;
      }
    }
  }
  loadBannerImages() {
    if (this.userProfile.company.region == 'USA' || this.userProfile.company.region == 'CANADA' || this.userProfile.company.region == 'LATAM') {
      this.imageUrlArray = [
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png',
          isLink: false
        },
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards_Q3Q4-Banners_1800x450_v2-Q3.jpg',
          isLink: false
        },
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards_Q3Q4-Banners_1800x450_v2-Q2.jpg',
          isLink: false
        },
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards_Q3Q4-Banners_1800x450_Q2.jpg',
          isLink: false
        },
        {
          url: 'assets/images/bannerimg/AMER_Featured_Sales_Challenge_Banner.jpg',
          isLink: true
        },
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards-QuarterlyWinners_Banner_1800x450.jpg',
          isLink: true
        }
        // 'assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png',
        // 'assets/images/bannerimg/Cisco_SellerRewards-QuarterlyWinners_Banner_1800x450.jpg',        
        // 'assets/images/bannerimg/CiscoDigitalLearning_Quiz_Banner_1800x450.jpg',
        // 'assets/images/bannerimg/DealRegistrationTransition_Quiz_Banner_1800x450.jpg',      
      ];
    }
    else if (this.userProfile.company.region == 'APJ') {
      this.imageUrlArray = [
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png',
          isLink: false
        },
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards_Q3Q4-Banners_1800x450_v2-Q3.jpg',
          isLink: false
        },
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards_Q3Q4-Banners_1800x450_v2-Q2.jpg',
          isLink: false
        },
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards_Q3Q4-Banners_1800x450_Q2.jpg',
          isLink: false
        },
        {
          url: 'assets/images/bannerimg/APJ_Featured_Sales_Challenge_Banner.jpg',
          isLink: true
        },
        {
          url: 'assets/images/bannerimg/Cisco_SellerRewards-QuarterlyWinners_Banner_1800x450.jpg',
          isLink: true
        }
        // 'assets/images/bannerimg/Cisco_SellerRewards-indigo-rafting_1800x450.png',
        // 'assets/images/bannerimg/Cisco_SellerRewards-QuarterlyWinners_Banner_1800x450.jpg',
        // 'assets/images/bannerimg/DealRegistrationTransition_Quiz_Banner_1800x450.jpg'          
      ];
    }
    //console.log(this.imageUrlArray.length,'length');
    // this.hideIndicators = this.imageUrlArray.length > 1 ? false : true
  }
  htmlProperty(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  checkDateValidity(slide) {
    let td = new Date();
    return CheckDateValidityPipe.prototype.transform(slide.startDate.substring(0, 10), slide.endDate.substring(0, 10), td.getFullYear() + '-' + Number(td.getMonth() + 1) + '-' + td.getDate());
    // return (new Date().getTime() <= new Date(slide.endDate).getTime() && new Date().getTime() >= new Date(slide.startDate).getTime()); 
  }

  onClickApproval(status,listData){
    const dialogRef = this.dialog.open(ApproverconformationComponent, {
      data:{'name':status,'approverData':listData},
       width:'36%',
      height: "370px", 
      panelClass: 'approver-info',
    });
    dialogRef.afterClosed().subscribe(result => {
   if(result){
    var msg = 'Status updated successfully.';
    this.popupMessageService.showSuccess(msg, 'success');
    this.getActivityGridData(this.selectedActivityId);
    this.getCountofApprovals()
   }
  
    });
  }
  openChatModal() {
    this.showChatScreen=true; 
  }
  onClickChat(chat,data){
    const dialogRef = this.dialog.open(ApproverconformationComponent, {
      data:{name:chat,approverData:data},width:'950px', panelClass: 'approver-info',
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  getActivityChgList(){

    this.approverService.getActivityList().subscribe((res)=>{
      if(res.length>0){
        this.activityList=res;
        // this.activityName=res[0].name;
      //   this.getActivityGridData(res[0].id)
         this.selectedActivityId=res[0].id;
         this.getCountofApprovals();
      }

    })
  }
  // get table data based on selection of challenge
  getActivityGridData(id,i?,eve?){
    if(eve){
      this.page=eve;
    }
    this.selectedActivityId=id;
    if(this.partnerName || this.partnerUser || this.category || this.approverEmail || this.approvalStatus){
      this.OnClickSearchBtn('&partnerName='+this.partnerName+'&partnerUser='+this.partnerUser+'&category='+this.category+'&email='+this.approverEmail+'&status='+this.approvalStatus);
    }else{
     
      let req;
      req='?activityChallengeId='+this.selectedActivityId+'&page='+(this.page-1)+'&size='+this.size
      this.approverService.getactivityGridData(req).subscribe((res)=>{
        if(res){
          this.approverList=res;
        }
    
      },(error)=>{
        console.log(error)
      })
    }

  }
  onChangeActivity(e){
    
    this.approvedCount=0;
    this.pendingApprovalCount=0;
    this.rejectedCount=0;
    this.page=1;
    this.clearSearch();
    let eve=e.target.value.split(',');
    
    this.getActivityGridData(eve[0])
    this.getCountofApprovals();
   
    this.activityName=eve[1]
  }
  // On click on download icon 
  downloadFile(url){
    window.open(url, '_blank').focus();
  }
  getCountofApprovals(){
    this.approverService.getApprovalCount(this.selectedActivityId).subscribe(res=>{
      if(res){
        res.forEach(val=>{
          if(val.status=='APPROVED'){
            this.approvedCount=val.count;
          }
          if(val.status=='PENDING_APPROVAL'){
            this.pendingApprovalCount=val.count;
          }
          if(val.status=='REJECTED'){
            this.rejectedCount=val.count;
          }
        })
      }
    })
  }
  // on click on search get approval list
  OnClickSearchBtn(searchText){
   
    let req='activityChallengeId='+this.selectedActivityId+'&page='+(this.page-1)+'&size='+this.size+searchText
    this.approverService.getApprovalListBySearch(req).subscribe(res=>{
      this.approverList=res;
    },(error)=>{
      console.log(error)
    })
  }


  clearSearch(){
    this.partnerName='';
    this.approvalStatus='';
    this.partnerUser='';
    this.category='';
    this.approverEmail='';
  }
 
  onSearch(){
    let i=0;
    if (this.searchCount==0){
      this.searchDiv=true;
      this.searchCount++;
    }else{
      if(this.partnerName || this.partnerUser || this.category || this.approverEmail || this.approvalStatus){
        this.closeIconFlag=true;
        this.OnClickSearchBtn('&partnerName='+this.partnerName+'&partnerUser='+this.partnerUser+'&category='+this.category+'&email='+this.approverEmail+'&status='+this.approvalStatus);
      }else{
       
      }
      
    }
  }
  ngOnDestroy(): void {
    let ciscoLinkElement = document.head.querySelector(`link[rel="stylesheet"].${'cisco_styles'}`);
    if (ciscoLinkElement) {
      document.head.removeChild(ciscoLinkElement);
    };
  };
}
